import Component from '@bythepixel/component-loader';

export default class FormSelect extends Component {
  static selector = '[data-comp-select-wrapper]';

  constructor(...args) {
    super(...args);
    this.selectEl = this.$container.querySelector('[data-comp-select]');
    this.clearIconEl = this.$container.querySelector('[data-comp-select-clear-icon]');
    this.arrowIconEl = this.$container.querySelector('[data-comp-select-arrow-icon]');
    this.hiddenClass = 'tw-select__icon--hidden';
    this.activeClass = 'tw-select--active';

    this.events();
  }

  events() {
    this.$container.addEventListener('input', (e) => {
      this.handleSelectEvent(e);
    });
    this.addClearIconEventListener();
  }

  handleSelectEvent(e) {
    this.selectEl.value = e.target.value;

    if (e.target.value) {
      this.handleSelectValueChange();
    } else {
      this.resetSelectState();
    }
  }

  handleSelectValueChange() {
    this.showSelectClearIcon();
    this.selectEl.classList.add(this.activeClass);
  }

  resetSelectState() {
    this.selectEl.value = '';
    this.showSelectArrowIcon();
    this.selectEl.classList.remove(this.activeClass);
  }

  addClearIconEventListener() {
    this.removeClearIconHandler = this.handleClearIconClick.bind(this);

    this.clearIconEl.addEventListener('click', this.removeClearIconHandler);
  }

  removeClearIconEventListener() {
    this.clearIconEl.removeEventListener('click', this.removeClearIconHandler);
  }

  handleClearIconClick() {
    const eventOptions = {
      bubbles: true,
      detail: {
        inputCleared: true,
      },
    };

    this.selectEl.value = '';
    this.selectEl.dispatchEvent(new CustomEvent('input', eventOptions));
    this.showSelectArrowIcon();
  }

  showSelectArrowIcon() {
    this.arrowIconEl.classList.remove(this.hiddenClass);
    this.clearIconEl.classList.add(this.hiddenClass);
  }

  showSelectClearIcon() {
    this.arrowIconEl.classList.add(this.hiddenClass);
    this.clearIconEl.classList.remove(this.hiddenClass);
  }
}
